export const getWorkspacesQuery = `
  {
    allWorkspaces {
        id
        name
        provider
    }
  }`;
